import React from 'react';

import FormikSelect from 'src/components/formik/FormikSelect';
import {
  Account, Contact, Step
} from 'src/types';
import useGetRequest from 'src/hooks/useGetRequest';
import CRUDConfigForm from 'src/components/formik/CRUDConfigForm';
import FormikChipAutocomplete from 'src/components/formik/FormikChipAutocomplete';

interface Props {
  step: Step,
  onSuccess: () => void,
}

const AutoAssignmentPolicyForm = ({ step, onSuccess }: Props) => {
  const {
    result: contacts,
    isLoading: contactsLoading,
  }: {
    result: Contact[],
    isLoading: boolean,
  } = useGetRequest({
    url: '/automatic/contacts/',
    initialResult: []
  });

  const { result: roles, isLoading: rolesLoading } = useGetRequest({
    url: `/automatic/workflows/${step.workflowId}/roles/`,
    initialResult: [],
  });

  if (contactsLoading || rolesLoading) return null;

  const fieldsConfig = [
    {
      name: 'roleId',
      component: () => (
        <FormikSelect
          fullWidth
          label="Role"
          name="roleId"
          options={roles.map((role: any) => ({
            value: role.id,
            label: role.name
          }))}
        />
      ),
    },
    {
      name: 'accountIds',
      component: () => (
        <FormikChipAutocomplete
          name="accountIds"
          options={contacts.map(({ account }) => account)}
          getOptionLabel={(account: Account) => `${account.firstName} ${account.lastName}`}
          getOptionKey={(account: Account) => account.id}
          label="Users who can be auto assigned to this role"
        />
      ),
    },
    {
      // todo - this should be some sort of radio button component instead
      name: 'policy',
      component: () => (
        <FormikSelect
          fullWidth
          label="Auto assignment policy"
          name="policy"
          options={[
            {
              label: 'Assign to the user with the least number of active engagements for this workflow',
              value: 'TO_LIGHTEST_WORKLOAD',
            },
            {
              label: 'Assign to users in alphabetical order',
              value: 'ROUND_ROBIN',
            },
          ]}
        />
      ),
    },
  ];

  return (
    <CRUDConfigForm
      url={`/automatic/workflows/${step.workflowId}/auto-assignment-policies/`}
      objectId={step.action && step.action.autoAssignmentPolicy && step.action.autoAssignmentPolicy.id}
      fieldsConfig={fieldsConfig}
      onSuccess={onSuccess}
      autoSave
    />
  );
};

export default AutoAssignmentPolicyForm;
